var _defs, _g, _path, _path2, _path3, _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22742",
    "data-name": "Group 22742",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 109.944,
    height: 128.494,
    viewBox: "0 0 109.944 128.494",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.136,
    y1: 0.31,
    x2: 0.841,
    y2: 0.895,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2bd27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f28b27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.136,
    y1: 0.31,
    x2: 0.841,
    y2: 0.895,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.136,
    y1: 0.31,
    x2: 0.841,
    y2: 0.895,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.136,
    y1: 0.31,
    x2: 0.841,
    y2: 0.895,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.136,
    y1: 0.31,
    x2: 0.841,
    y2: 0.895,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.389,
    y1: 0.273,
    x2: 0.73,
    y2: 0.969,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#57111f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334,
    stopColor: "#8a1c32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.65,
    y1: 0.194,
    x2: 0.345,
    y2: 0.815,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e1b1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334,
    stopColor: "#9b1f37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.158,
    y1: 0.23,
    x2: 0.863,
    y2: 0.787,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.158,
    y1: 0.23,
    x2: 0.864,
    y2: 0.787,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22738",
    "data-name": "Group 22738",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13892",
    "data-name": "Path 13892",
    d: "M838.684,64.4l5.373,10.782,11.911,1.774L847.382,85.4l1.985,11.88-10.683-5.565L828,97.28l1.985-11.88L821.4,76.957l11.911-1.774Z",
    transform: "translate(-783.712 -64.4)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13893",
    "data-name": "Path 13893",
    d: "M408.808,379.3l3.822,7.674,8.481,1.266-6.117,6.012,1.414,8.456-7.6-3.958-7.606,3.958,1.414-8.456L396.5,388.24l8.481-1.266Z",
    transform: "translate(-385.172 -359.764)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13894",
    "data-name": "Path 13894",
    d: "M223.435,787.3l2.965,5.949,6.576.98-4.74,4.659,1.092,6.551-5.894-3.071-5.894,3.071,1.1-6.551-4.74-4.659,6.57-.98Z",
    transform: "translate(-213.9 -742.453)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13895",
    "data-name": "Path 13895",
    d: "M1419.1,379.3l-3.822,7.674-8.481,1.266,6.117,6.012-1.414,8.456,7.6-3.958,7.606,3.958-1.414-8.456,6.117-6.012-8.481-1.266Z",
    transform: "translate(-1332.795 -359.764)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13896",
    "data-name": "Path 13896",
    d: "M1688.141,787.3l-2.965,5.949-6.576.98,4.74,4.659-1.092,6.551,5.894-3.071,5.894,3.071-1.1-6.551,4.74-4.659-6.57-.98Z",
    transform: "translate(-1587.732 -742.453)",
    fill: "url(#linear-gradient-5)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13897",
    "data-name": "Path 13897",
    d: "M1033.978,1513.2l12.129,29.865-13.642-2.854.05-.019-7.792,11.558-12.122-29.871Z",
    transform: "translate(-963.05 -1423.319)",
    fill: "url(#linear-gradient-6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13898",
    "data-name": "Path 13898",
    d: "M681.1,1521.177l-12.55,29.7-7.624-11.663.05.019-13.679,2.661,12.544-29.692Z",
    transform: "translate(-620.413 -1422.381)",
    fill: "url(#linear-gradient-7)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13899",
    "data-name": "Path 13899",
    d: "M637.787,686.444c0,1.694-2.066,3.2-2.32,4.82-.26,1.663,1.235,3.735.726,5.3-.515,1.594-2.947,2.388-3.7,3.865s.019,3.921-.955,5.261-3.536,1.352-4.715,2.531-1.185,3.735-2.531,4.715-3.778.2-5.261.955-2.271,3.183-3.865,3.7c-1.57.509-3.635-.986-5.3-.726-1.619.254-3.127,2.32-4.82,2.32s-3.2-2.066-4.82-2.32c-1.663-.26-3.735,1.235-5.3.726-1.594-.515-2.388-2.947-3.865-3.7s-3.921.019-5.261-.955-1.352-3.536-2.531-4.715-3.735-1.185-4.715-2.531-.2-3.778-.955-5.261-3.183-2.271-3.7-3.865c-.509-1.57.986-3.635.726-5.3-.254-1.619-2.32-3.127-2.32-4.82s2.066-3.2,2.32-4.82c.261-1.663-1.235-3.735-.726-5.3.515-1.594,2.947-2.388,3.7-3.865s-.019-3.921.955-5.261,3.536-1.352,4.715-2.531,1.185-3.735,2.531-4.715,3.778-.2,5.261-.955,2.271-3.183,3.865-3.7c1.57-.509,3.635.986,5.3.726,1.619-.254,3.127-2.32,4.82-2.32s3.2,2.066,4.82,2.32c1.663.261,3.735-1.235,5.3-.726,1.594.515,2.388,2.947,3.865,3.7s3.921-.019,5.261.955,1.352,3.536,2.531,4.715,3.735,1.185,4.715,2.531.2,3.778.955,5.261,3.183,2.271,3.7,3.865c.509,1.57-.986,3.635-.726,5.3C635.722,683.243,637.787,684.756,637.787,686.444Z",
    transform: "translate(-550.065 -617.141)",
    fill: "url(#linear-gradient-8)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_418",
    "data-name": "Ellipse 418",
    cx: 24.462,
    cy: 24.462,
    rx: 24.462,
    ry: 24.462,
    transform: "translate(30.51 44.841)",
    fill: "#fff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_419",
    "data-name": "Ellipse 419",
    cx: 22.154,
    cy: 22.154,
    rx: 22.154,
    ry: 22.154,
    transform: "translate(32.818 47.149)",
    fill: "url(#linear-gradient-9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/Gold.4705333bb416b13deb146b21574605c3.svg";
export { ForwardRef as ReactComponent };